import { useState, useEffect } from "react";
import { Plus, MapPin, Trash2 } from "lucide-react";
import api from "@/lib/api";

export default function GeofencePage() {
  const [fences, setFences] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", latitude: "", longitude: "", radius: 200 });
  const [saving, setSaving] = useState(false);

  const fetch = () => api.get("/workforce/geofences").then((r) => setFences(r.data)).catch(() => {});
  useEffect(() => { fetch(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post("/workforce/geofences", { ...form, latitude: Number(form.latitude), longitude: Number(form.longitude), radius: Number(form.radius) });
      setForm({ name: "", latitude: "", longitude: "", radius: 200 }); setShowForm(false); fetch();
    } catch { /* */ }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Remover este geofence?")) return;
    await api.delete(`/workforce/geofences/${id}`); fetch();
  };

  return (
    <div data-testid="geofence-page">
      <div className="flex items-center justify-between mb-8">
        <h1 className="crm-heading">Geofences</h1>
        <button onClick={() => setShowForm(!showForm)} className="crm-btn-primary"><Plus className="w-4 h-4" /> Novo Local</button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="crm-card p-6 mb-6 space-y-4">
          <h3 className="crm-subheading">Adicionar Local Permitido</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><label className="crm-label">Nome *</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="crm-input" placeholder="Escritório Tokyo" /></div>
            <div><label className="crm-label">Raio (metros)</label><input type="number" value={form.radius} onChange={(e) => setForm({ ...form, radius: e.target.value })} className="crm-input" /></div>
            <div><label className="crm-label">Latitude *</label><input required value={form.latitude} onChange={(e) => setForm({ ...form, latitude: e.target.value })} className="crm-input" placeholder="35.6762" /></div>
            <div><label className="crm-label">Longitude *</label><input required value={form.longitude} onChange={(e) => setForm({ ...form, longitude: e.target.value })} className="crm-input" placeholder="139.6503" /></div>
          </div>
          <div className="flex gap-3">
            <button type="submit" disabled={saving} className="crm-btn-primary text-sm">{saving ? "Salvando..." : "Adicionar"}</button>
            <button type="button" onClick={() => setShowForm(false)} className="crm-btn-secondary text-sm">Cancelar</button>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {fences.length === 0 ? (
          <div className="crm-card p-12 text-center" style={{ color: "var(--crm-text-dim)" }}>Nenhum geofence cadastrado</div>
        ) : fences.map((f) => (
          <div key={f.id} className="crm-card p-5 flex items-center justify-between" data-testid={`geofence-${f.id}`}>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: "rgba(16,185,129,0.1)", color: "#10b981" }}>
                <MapPin className="w-5 h-5" />
              </div>
              <div>
                <p className="text-base font-bold" style={{ color: "var(--crm-text)" }}>{f.name}</p>
                <p className="text-xs" style={{ color: "var(--crm-text-muted)" }}>{f.latitude}, {f.longitude} — Raio: {f.radius}m</p>
              </div>
            </div>
            <button onClick={() => handleDelete(f.id)} className="p-2 rounded-lg hover:text-red-400 transition-colors" style={{ color: "var(--crm-text-dim)" }}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
